import { Dispatch, SetStateAction, useCallback } from 'react';

import {
    AUTH_QUERY_KEY,
    AuthResponse,
    useGetTeamById,
    useUserProfile,
} from '@/features/auth/api';
import { UserProfile } from '@/features/auth/types';
import { useQueryClient } from '@tanstack/react-query';
import { useLocalStorage } from 'usehooks-ts';

// TODO: Refactor these to not return tuples
// TODO: Move some of these to their own files

export const AUTH_DATA_QUERY_KEY = 'auth:user';

export function useAuthData(): {
    accessToken: string;
    refreshToken: string;
    accessTokenExpiresAt: string;
    setAuthData: Dispatch<SetStateAction<AuthResponse | null>>;
} {
    const [authData, setAuthData] = useLocalStorage<AuthResponse | null>(
        AUTH_DATA_QUERY_KEY,
        null,
    );
    const accessToken = authData ? authData.accessToken : '';
    const refreshToken = authData ? authData.refreshToken : '';
    const accessTokenExpiresAt = authData ? authData.accessTokenExpiresAt : '';

    return {
        accessToken,
        refreshToken,
        accessTokenExpiresAt,
        setAuthData,
    };
}

export function useCurrentUser(options?: { refetchInterval?: number }): [
    UserProfile | null | undefined,
    Dispatch<SetStateAction<AuthResponse | null>>,
    boolean,
    () => void,
] {
    const { setAuthData } = useAuthData();

    const queryClient = useQueryClient();

    const { data: user, isLoading: userLoading } = useUserProfile(options);

    const refreshUser = useCallback(() => {
        queryClient.invalidateQueries({
            queryKey: [AUTH_QUERY_KEY, 'me'],
        });
    }, [queryClient]);

    return [user, setAuthData, userLoading, refreshUser];
}

export default function useApiKey(): [string] {
    const [user, _setUser, userLoading] = useCurrentUser();

    const { data: team } = useGetTeamById(user?.teamId || '');

    const apiKey =
        !userLoading && user && user.teamId ? team?.apiKey || '' : '';

    return [apiKey];
}
